interface ApiConstantsInterface {
  baseUrl: string
  getCustomerOrders: string
  getOrderDetails: (orderId: number) => string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/order',
  getCustomerOrders: `/history`,
  getOrderDetails: (orderId: number) => `/details?orderId=${Math.trunc(orderId)}`,
}

export { apiConstants, ApiConstantsInterface }
